import BillingsOrderCargoRailyAddParams, {
  BillingsOrderCargoRailyAddParamsBillingNode,
} from "../../../../../common/services/billings/order/cargo-raily/add/billings-order-cargo-raily-add-params";
import BillingsNode from "../../../common/types/billings-node";
import BillingFormData from "../types/billing-form.data";

const createSaveBillingRequestBillingNode = (
  billingNode: BillingsNode,
): BillingsOrderCargoRailyAddParamsBillingNode => {
  return {
    allowCharge: billingNode.isHighwayAllowed,
    checkoutDate: billingNode.checkoutDate,
    checkoutEventId: billingNode.checkoutEventUuid,
    description: billingNode.description,
    distance: billingNode.distance,
    editableCoordinates: billingNode.isEditable,
    haltingTime: billingNode.haltingTime,
    highwayCharge: billingNode.highwayCharge,
    id: billingNode.id,
    lat: billingNode.lat,
    lon: billingNode.lon,
    nodeId: billingNode.nodeId,
    orderId: billingNode.orderId,
    plannedDate: billingNode.plannedDate,
    plannedDistance: billingNode.plannedDistance,
  };
};

const createSaveBillingRequestBillingNodes = (
  billingNodes: BillingsNode[],
): BillingsOrderCargoRailyAddParamsBillingNode[] => {
  return billingNodes.map(createSaveBillingRequestBillingNode);
};

const createSaveBillingRequest = (
  data: BillingFormData,
): BillingsOrderCargoRailyAddParams => {
  return {
    billingNodes: createSaveBillingRequestBillingNodes(data.billingNodes),
    discount: data.discount,
    orderUuid: data.cargoOrderId,
  };
};

const billingSaveRequestFactory = {
  createSaveBillingRequest,
};

export default billingSaveRequestFactory;
